module.exports = __webpack_public_path__ + "img/succeed.07550877.png";